<template>
  <div class="withdraw-record">
    <van-nav-bar
      class="wr-nav"
      :title="$t('withdraw.log')"
      left-arrow
      @click-left="back()"
    />

    <div class="wr-main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('common.nodata')" />
        <div v-else class="wr-list">
          <div v-for="(item, i) in list" :key="i" class="wr-card">
            <div class="wr-card-head">
              <span class="wr-amount">{{ $t('withdraw.title') }}{{ item.money }} TWD</span>
              <span class="wr-status" :class="statusClass(item.status)">{{ statusExt[item.status] }}</span>
            </div>

            <div v-if="targetLines(item).length" class="wr-target">
              <p v-for="(line, j) in targetLines(item)" :key="j" class="wr-target-line">{{ line }}</p>
            </div>

            <div class="wr-card-foot">
              <span class="wr-time">{{ item.create_time }}</span>
              <button type="button" class="wr-notice" @click="showD(item.desc)">
                {{ $t('notification') }}
              </button>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';

export default {
  data() {
    return {
      isLoading: false,
      list: [],
      statusExt: [
        '',
        this.$t('withdraw.status1'),
        this.$t('withdraw.status2'),
        this.$t('withdraw.status3'),
      ],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    statusClass(status) {
      const s = Number(status);
      if (s === 2) return 'is-success';
      if (s === 3) return 'is-fail';
      return 'is-pending';
    },
    targetLines(item) {
      const raw = item.withdraw_target;
      if (!raw || !String(raw).trim()) {
        return [];
      }
      return String(raw)
        .trim()
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter(Boolean);
    },
    async onRefresh() {
      try {
        await this.getUserWithdrawList();
      } finally {
        this.isLoading = false;
        this.$toast(this.$t('common.refresh'));
      }
    },
    showD(desc) {
      Dialog.alert({
        title: this.$t('notification'),
        message: desc != null && String(desc) !== '' ? String(desc) : '—',
        confirmButtonText: '確認',
        messageAlign: 'left',
        width: '88%',
        className: 'wr-notice-dialog',
      });
    },
    getUserWithdrawList() {
      return this.$http({
        method: 'get',
        url: 'user_get_withdraw_list',
      }).then((res) => {
        if (res.code === 200) {
          this.list = Array.isArray(res.data) ? res.data : [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

@grad-start: #f560cd;
@grad-end: #4f2b8a;

.withdraw-record {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f3f5;
}

.wr-nav {
  flex-shrink: 0;
}

.withdraw-record::v-deep .wr-nav.van-nav-bar {
  background: linear-gradient(90deg, @grad-start, @grad-end);
}

.withdraw-record::v-deep .wr-nav.van-nav-bar::after {
  display: none;
}

.withdraw-record::v-deep .wr-nav .van-nav-bar__title {
  color: #fff;
  font-size: 34px;
  font-weight: 600;
}

.withdraw-record::v-deep .wr-nav .van-icon {
  color: #fff;
  font-size: 36px;
}

.wr-main {
  flex: 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 24px;
  box-sizing: border-box;
}

.withdraw-record::v-deep .van-pull-refresh {
  min-height: 50vh;
}

.wr-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.wr-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px 16px;
  box-shadow: 0 2px 12px rgba(79, 43, 138, 0.06);
  box-sizing: border-box;
}

.wr-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wr-amount {
  flex: 1;
  min-width: 0;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.35;
  color: #1989fa;
  text-align: left;
}

.wr-status {
  flex-shrink: 0;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.35;
  white-space: nowrap;
}

.wr-status.is-pending {
  color: #969799;
}

.wr-status.is-success {
  color: #07c160;
}

.wr-status.is-fail {
  color: #ee0a24;
}

.wr-target {
  margin-top: 12px;
  padding: 12px 0 0;
  border-top: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
}

.wr-target-line {
  margin: 0;
  padding: 0;
  font-size: 26px;
  line-height: 1.5;
  color: #555;
  text-align: left;
  text-indent: 0;
  word-break: break-all;
}

.wr-target-line + .wr-target-line {
  margin-top: 6px;
}

.wr-card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.wr-time {
  font-size: 24px;
  color: #999;
  line-height: 1.4;
}

.wr-notice {
  flex-shrink: 0;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 24px;
  color: #735fb1;
  background: #f3f0fa;
  -webkit-tap-highlight-color: transparent;
}

</style>

<!-- Dialog.alert 掛載在 body，與本頁根節點無父子關係，scoped 無法命中，須單獨全域樣式 -->
<style lang="less">
.wr-notice-dialog.van-dialog {
  width: 88% !important;
  max-width: 92vw;
}

.wr-notice-dialog .van-dialog__content {
  padding: 18px 22px 12px !important;
}

.wr-notice-dialog .van-dialog__message {
  padding: 20px 8px 24px !important;
  font-size: 34px !important;
  line-height: 1.55 !important;
  color: #333 !important;
  text-align: left !important;
  word-break: break-all !important;
}

.wr-notice-dialog .van-dialog__confirm {
  font-size: 30px !important;
  height: auto !important;
  min-height: 48px;
}

.wr-notice-dialog .van-dialog__footer .van-button {
  font-size: 30px !important;
}
</style>
